import React, {useState} from 'react';
// import { BrowserRouter as Router, Route, useParams } from 'react-router-dom';
import {BrowserRouter as Router, Routes, Route, useParams} from 'react-router-dom';

// import { DeviceProvider } from './context/DeviceContext';
// import DeviceLoader from './context/DeviceLoader';
// import useSession from './hooks/useSession'; // Session ID'yi alacak hook
// import useSSE from './hooks/useSSE';
// import DeviceList from './components/DeviceList'; // Cihaz listesini gösterecek bileşen
// import SSEListener from './hooks/SSEListener';
import ErrorBoundary from './ui/ErrorBoundary';
import ErrorPage from './ui/ErrorPage';
import MainApp from './ui/MainApp';
import LoginPage from './ui/LoginPage';

import './css/app.css';

// const App = () => {
//   const sessionId = useSession(); // Session ID'yi alıyoruz
//   const [loaded, setLoaded] = useState(false); // Cihazlar yüklendi mi diye kontrol için flag
//   console.log(`App-sessionId: ${sessionId}`);
//   if (!sessionId) {
//     return <div>loading...</div>
//   }

//   return (
//     <DeviceProvider> {/* DeviceProvider tüm bileşenleri sarıyor */}
//       <DeviceLoader sessionId={sessionId} onLoaded={() => setLoaded(true)} /> {/* Cihazlar yüklendiğinde flag güncelleniyor */}
//       {loaded && <SSEListener sessionId={sessionId} />} {/* Cihazlar yüklendikten sonra SSE başlatılır */}
//       <div className="App">
//         <h1>Device List</h1>
//         <DeviceList /> {/* Cihazları listeleyecek */}
//       </div>
//     </DeviceProvider>
//   );
// };

// App bileşenini Route içine yerleştiriyoruz
// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/:data/:hash" element={<MainApp />} />
//         {/* Diğer Route tanımlarınızı buraya ekleyin */}
//       </Routes>
//     </Router>
//   );
// };


const App: React.FC = () => {
  return (
    <Router>
      <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/:data/:hash" element={<MainApp />} />
          <Route path="/error" element={<ErrorPage />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
}


export default App;